import { render, staticRenderFns } from "./AddFab.vue?vue&type=template&id=b24a5698&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddFab.vue"
export default component.exports